export const MIN_POLE_LENGTH = 20;
export const MAX_POLE_LENGTH = 125;
export const POLE_LENGTH_INCREMENT = 5;

export function poleLengths() {
	const result: number[] = [];
	for (let i = MIN_POLE_LENGTH; i <= MAX_POLE_LENGTH; i += POLE_LENGTH_INCREMENT) {
		result.push(i);
	}
	return result;
}

/**
 * ANSI O5.1 Wood Pole Classes
 */
export enum PoleClass {
	H6 = 'H6',
	H5 = 'H5',
	H4 = 'H4',
	H3 = 'H3',
	H2 = 'H2',
	H1 = 'H1',
	Class1 = '1',
	Class2 = '2',
	Class3 = '3',
	Class4 = '4',
	Class5 = '5',
	Class6 = '6',
	Class7 = '7',
	Class9 = '9',
	Class10 = '10',
}

export function normalClasses(): PoleClass[] {
	return [
		PoleClass.Class1,
		PoleClass.Class2,
		PoleClass.Class3,
		PoleClass.Class4,
		PoleClass.Class5,
		PoleClass.Class6,
		PoleClass.Class7,
		PoleClass.Class9,
		PoleClass.Class10,
	];
}

export function hClasses(): PoleClass[] {
	return [PoleClass.H1, PoleClass.H2, PoleClass.H3, PoleClass.H4, PoleClass.H5, PoleClass.H6];
}

export function isPoleClass(val: string): val is PoleClass {
	return Object.values(PoleClass).includes(val as PoleClass);
}

/**
 * Returns the list of pole lengths (in feet) which are defined for the given Pole Class.
 * For example, this function returns [20, 25] for PoleClass.Class10.
 */
export function poleLengthsForClass(poleClass: PoleClass) {
	switch (poleClass) {
		case PoleClass.H6:
			return poleLengths();
		case PoleClass.H5:
			return poleLengths();
		case PoleClass.H4:
			return poleLengths();
		case PoleClass.H3:
			return poleLengths();
		case PoleClass.H2:
			return poleLengths();
		case PoleClass.H1:
			return poleLengths();
		case PoleClass.Class1:
			return poleLengths();
		case PoleClass.Class2:
			return poleLengths();
		case PoleClass.Class3:
			return poleLengths().filter((length) => length <= 90);
		case PoleClass.Class4:
			return poleLengths().filter((length) => length <= 70);
		case PoleClass.Class5:
			return poleLengths().filter((length) => length <= 50);
		case PoleClass.Class6:
			return poleLengths().filter((length) => length <= 45);
		case PoleClass.Class7:
			return poleLengths().filter((length) => length <= 35);
		case PoleClass.Class9:
			return poleLengths().filter((length) => length <= 30);
		case PoleClass.Class10:
			return poleLengths().filter((length) => length <= 25);
		default:
			throw new Error(`Unrecognized PoleClass: ${poleClass}`);
	}
}
